import { getApiServerUri } from "../config/client";

export function getApiBaseUrl() {
  if (typeof window !== "undefined") {
    const hostname = String(window.location.hostname || "").toLowerCase();
    const isHostedWeb =
      hostname === "timely365.com" ||
      hostname === "www.timely365.com" ||
      hostname === "plany365.com" ||
      hostname === "www.plany365.com";
    if (isHostedWeb) return "";
  }

  const uri = getApiServerUri();
  if (!uri) return "";
  try {
    const parsed = new URL(uri, window.location.origin);
    parsed.pathname = parsed.pathname.replace(/\/graphql\/?$/i, "");
    parsed.search = "";
    parsed.hash = "";
    return parsed.toString().replace(/\/+$/, "");
  } catch {
    return "";
  }
}
